import DirtBike from 'assets/images/psp/hero/dirt-bike-hero.webp';
import bike5x10 from 'assets/images/psp/Dirt-Bike/dirt-bike-5x10.svg';
import bike10x10 from 'assets/images/psp/Dirt-Bike/dirt-bike-10x10.svg';
import bike10x15 from 'assets/images/psp/Dirt-Bike/dirt-bike-10x15.svg';
import bike10x20 from 'assets/images/psp/Dirt-Bike/dirt-bike-10x20.svg';
import DirtBikeContentImage from 'assets/images/psp/Dirt-Bike/dirtbike.webp';
import dirtbikeFeatured1 from 'assets/images/psp/FeaturedImages/motorcycle1.webp';
import dirtbikeFeatured2 from 'assets/images/psp/FeaturedImages/car4.webp';
import dirtbikeFeatured3 from 'assets/images/psp/FeaturedImages/car1.webp';

const faqs = [
	{
		question: 'Can you store a dirt bike in a storage unit?',
		answer:
			'Yes. It’s a great storage solution for your dirt bike. Storing your bike in a storage unit is not only allowed but highly beneficial. ' +
			"It's one of the most popular vehicle storage solutions we help customers find. Most storage facilities welcome dirt bikes, and many specialize " +
			'in recreational vehicle storage with features designed specifically for two-wheeled vehicles.',
	},
	{
		question: 'Do I need a climate-controlled dirt bike storage unit?',
		answer:
			"Climate control isn't necessary for every dirt bike, but it's valuable for certain situations. If your bike has sensitive electronics or you're storing it in a region with extreme temperature swings or high humidity, climate control is worth the extra investment. \n\n" +
			'Modern fuel-injected bikes with advanced electronics, GPS systems, and digital displays benefit from stable temperatures. Temperature fluctuations cause condensation, which can damage electrical components, corrode metal parts, and create moisture issues in fuel systems. Vintage bikes or carbureted models are generally more tolerant of temperature variations. \n\n' +
			"Climate control also protects rubber components like tires, seals, and hoses from cracking due to extreme temperatures. If you're storing expensive gear alongside your bike – leather boots, helmets, or protective equipment, climate control prevents deterioration and extends their lifespan. \n\n" +
			'Storage duration is a factor to consider as well. Short-term storage rarely requires climate control, but longer or multi-seasonal storage periods increase the risk of moisture and temperature damage. Geographic location matters significantly. Storage in hot or humid areas like Arizona, Florida, or other extreme climates benefits more from climate control than moderate regions. \n\n',
	},
	{
		question: 'How to prepare my dirt bike for winter storage?',
		answer:
			'Start with a thorough cleaning – remove all dirt, mud, and debris that could trap moisture and cause corrosion. Pay special attention to the chain, sprockets, and any areas where salt or grime might accumulate. \n\n' +
			'Drain the fuel tank completely or add high-quality fuel stabilizer and run the engine for 5-10 minutes to circulate treated fuel through the system. Untreated fuel can gum up carburetors and fuel injection components during extended storage. \n\n' +
			"Change the engine oil and filter, even if they're not due for replacement. Used oil contains acids and contaminants that can damage internal components during storage. Remove the battery and store it in a cool, dry location, ideally connected to a battery tender to maintain charge throughout winter. \n\n" +
			"Check tire pressure and inflate to the maximum recommended PSI, or use a motorcycle stand to remove weight from tires and suspension components. This prevents flat spots and maintains suspension seals. Lubricate the chain and all moving parts according to your owner's manual. \n\n" +
			"Lastly, cover your bike with a breathable cover. Avoid plastic tarps that trap moisture. If storing in a non-climate-controlled unit, consider moisture absorbers to prevent condensation issues. Document your bike's condition with photos and check on it monthly if possible. \n\n",
	},
	{
		question: 'How do I take my dirt bike out of storage?',
		answer:
			'Taking your dirt bike out of storage properly ensures a safe, successful return to the trails. Start your inspection before even attempting to start the engine – check for any signs of rodent damage, moisture issues, or security concerns that might have occurred during storage. \n\n' +
			'Reinstall the battery if you removed it, ensuring clean, tight connections. Check all fluid levels, including oil, coolant, and brake fluid. If you drained the fuel system, add fresh gasoline. If you used a fuel stabilizer, the existing fuel should be fine, but adding some fresh fuel helps dilute any degraded components. \n\n' +
			'Inspect tires for proper pressure and any signs of cracking or flat spots. Check the chain for proper tension and lubrication – apply fresh chain lube if needed. Look over cables, controls, and lights to ensure everything operates smoothly. \n\n' +
			'Before your first ride, start the engine and let it warm up properly. Check that all electrical components are working correctly and that the bike shifts through all gears smoothly. Take a short test ride in a safe area to verify that the brakes, clutch, and handling feel normal. \n\n' +
			'Consider this an opportunity for a thorough inspection. Check the air filter condition, brake pad wear, and any maintenance items that might be due. Many riders schedule a professional tune-up when taking bikes out of long-term storage to ensure everything is trail-ready. \n\n',
	},
	{
		question: "What's the best way to organize a dirt bike storage unit?",
		answer:
			' When it comes to dirt bike storage unit organization, it’s best to compartmentalize. Think in zones, not piles. Create a bike parking area near the door, gear storage along one wall, and maintenance supplies in the back. Use vertical space with shelving for helmets, boots, and gear. Keep frequently used items accessible and seasonal items toward the back.\n\n' +
			'Invest in clear storage bins for parts and accessories. Label everything. Use bike stands or hooks to maximize floor space. Consider a small workbench if your unit allows it. The goal is functionality, not just storage.\n\n',
	},
];

const videoDescription = [
	'Your dirt bike isn’t just another utility like a lawn mower or another bulky item that needs to be stowed away until you need it. It’s an investment, a vehicle, and a source of excitement. Riders like you know that a dirt bike storage solution needs: \n\n ' +
		"- **Accessibility** that doesn't require a PhD in physics to get your bike in and out.\n\n" +
		'- **Proper ventilation** to prevent condensation and corrosion issues.\n\n' +
		'- **Security that works** against thieves who specifically target recreational vehicles.\n\n' +
		'- **Space for the ecosystem** because a dirt bike is never just a dirt bike—there are kits, tools, helmets, gloves, gas cans, and countless other accessories.\n\n',
];

const reviews = [
	{
		reviewTitle: 'Very easy to make a reservation.',
		reviewRating: 5,
		reviewText:
			'It was very easy to make a reservation. Took less than a minute. Love it!!',
		reviewerInitials: 'KT',
		link: 'https://www.trustpilot.com/users/686a97152824b56fab2f6f6c',
		reviewerName: 'Kevin Tate',
		reviewDate: 'Jul 6, 2025',
	},
	{
		reviewTitle: 'Great location and easily accessible…',
		reviewRating: 5,
		reviewText:
			'Great location and easily accessible facility. The manager was honest and knowledgeable about the layout of the storage units. Cost is fairly reasonable.',
		reviewerInitials: 'RN',
		link: 'https://www.trustpilot.com/reviews/68641a442787f52521d81d18',
		reviewerName: 'Reggie N',
		reviewDate: 'Jul 2, 2025',
	},
	{
		reviewTitle: 'SpareFoot was great…',
		reviewRating: 5,
		reviewText:
			'SpareFoot was great in facilitating and finding a great spot for my storage needs. Everything went smoothly, and the information provided was accurate.',
		reviewerInitials: 'MN',
		link: 'https://www.trustpilot.com/reviews/6854443175ec746a306cbffc',
		reviewerName: 'Miller, Norman E',
		reviewDate: 'Jun 20, 2025',
	},
	{
		reviewTitle: 'Top Search, Best Find!!!',
		reviewRating: 5,
		reviewText:
			'SpareFoot appeared in a search for cheap storage options. With SpareFoot, I was able to quickly find a new facility, closer to home, with the same size unit for $200 less than others! This site was right on time—I had just signed a lease for a new place to downsize and save money. SpareFoot essentially came to my rescue in more ways than one!',
		reviewerInitials: 'AB',
		link: 'https://www.trustpilot.com/reviews/685e17aa215632957faec95c',
		reviewerName: 'Angela Beale',
		reviewDate: 'Jun 27, 2025',
	},
];

export const DirtBikeContent = {
	type: 'Dirt-Bike',
	sections: [
		{
			title: 'Dirt Bike Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'dirt-bike-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Dirt Bike Storage For You',
							description:
								'Your dirt bike is always there for you, kicking up the mud life’s trying to drag you through. Treat your ride like the friend it is by giving it a dignified storage space that’s not a small corner of your driveway or tucked in the shed of shame. There are a lot of dirt bike storage solutions out there, but few are as effective as a storage unit for your dirt bike. Forget about the cramped garage or the haphazardly built [dirt bike storage shed](https://www.sparefoot.com/blog/storage-units-vs-storage-sheds-better) you bought with the best of intentions. SpareFoot is here to connect you with storage units close to home that offer rider-friendly amenities like ground-level access, tight security, [climate control](https://www.sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit), and enough extra space for all your gear.',
							image: DirtBike,
							CTAText: 'Find Dirt Bike Storage',
						},
					},
				},
			],
		},

		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Dirt Bike Storage Facilities Near',
					},
				},
			],
		},

		{
			title: 'video content',
			modules: [
				{
					title: 'Dirt Bike Content',
					type: 'content',
					ShowBackgroundImage: false,
					props: {
						title: 'The Perks of Storing a Dirt Bike in a Storage Unit',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: DirtBikeContentImage,
						content: videoDescription,
					},
				},
			],
		},

		{
			title: 'Size Guide',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						title: 'Dirt Bike Storage Unit Costs',
						content: [
							"Understanding dirt bike storage costs goes beyond just the monthly rent – it's about getting the right value for your needs. \n\n" +
								'Storage prices typically range from $59 for basic outdoor coverage to $189+ for premium indoor units with all the amenities. But the real question is… which features matter for your situation? \n\n' +
								'This guide breaks down what you get at each price point, from basic bike-only storage to full workshop setups with climate control and 24/7 access. \n\n',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Size',
								key: 'Size',
							},
							{
								label: 'Mostly Cost',
								key: 'Mostly Cost',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
							{
								label: 'Electricity',
								key: 'Electricity',
							},
							{
								label: 'Ground Floor or Drive Up Access',
								key: 'Ground Floor or Drive Up Access',
							},
							{
								label: '24/7 Access',
								key: '24/7 Access',
							},
							{
								label: 'Climate Control',
								key: 'Climate Control',
							},
						],

						rows: [
							{
								Size: {
									type: 'markdown',
									markdown:
										'[**5x10**](https://www.sparefoot.com/blog/5x10-storage-unit-size-guide)',
								},
								'Mostly Cost': '$69-89',
								'What Fits': '1 bike only',
								Electricity: 'Powered outlets',
								'Ground Floor or Drive Up Access':
									'Convenience',
								'24/7 Access': 'Flexibility',
								'Climate Control':
									'Weather, heat, and humidity protection',
							},
							{
								Size: {
									type: 'markdown',
									markdown:
										'[**10x10**](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Mostly Cost': '$89-119',
								'What Fits': '1 bike + gear',
								Electricity:
									'Fit for battery tender/maintainer',
								'Ground Floor or Drive Up Access':
									'Convenience',
								'24/7 Access': 'Flexibility',
								'Climate Control':
									'Weather, heat, and humidity protection',
							},
							{
								Size: {
									type: 'markdown',
									markdown:
										'[**10x15**](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Mostly Cost': '$119-149',
								'What Fits': '2 bikes or 1 bike + trailer',
								Electricity: 'Install lighting, use tools',
								'Ground Floor or Drive Up Access':
									'Convenience',
								'24/7 Access': 'Flexibility',
								'Climate Control':
									'Weather, heat, and humidity protection',
							},
							{
								Size: {
									type: 'markdown',
									markdown:
										'[**10x20**](https://www.sparefoot.com/blog/10x20-storage-unit-size-guide)',
								},
								'Mostly Cost': '$149-189',
								'What Fits': '3+ bikes or workshop setup',
								Electricity: 'Workshop potential',
								'Ground Floor or Drive Up Access':
									'Convenience',
								'24/7 Access': 'Flexibility',
								'Climate Control':
									'Weather, heat, and humidity protection',
							},
							{
								Size: {
									type: 'markdown',
									markdown: '**Outdoor**',
								},
								'Mostly Cost': '$59-79',
								'What Fits': 'Any bike',
								Electricity: 'Not available',
								'Ground Floor or Drive Up Access':
									'Convenience',
								'24/7 Access': 'Flexibility',
								'Climate Control': 'Not available',
							},
						],
					},
				},
			],
		},

		{
			title: 'Content section - single column',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Dirt Bike Storage Solutions At A Glance',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'- **5x10**: Basic storage, tight fit.\n\n' +
								'- **10x10**: Most popular choice, room for bike and accessories\n\n' +
								'- **10x15**: Perfect for multi-bike collections\n\n' +
								'- **10x20**: Ideal storage and workshop space for serious riders\n\n' +
								'- **Outdoor**: Budget-friendly option, short-term, weather protection only\n\n',
						],
					},
				},
			],
		},

		{
			title: 'Size Comparison',
			background: 'white',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Dirt Bike Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"The key to successful dirt bike storage isn't just finding space – it's finding the right space. Here's how smart riders choose:\n\n",
						],
					},
				},
				{
					type: 'unitList',
					props: {
						title: 'Dirt Bike Storage Unit Size Guide',
						unitsData: [
							{
								image: bike5x10,
								content:
									'### 5x10 Storage Unit\n\n' +
									'**Best for**: Single bike owners who keep their gear elsewhere\n\n' +
									'**Monthly cost**: $69-89\n\n' +
									'**Pro tip**: Only consider this if you have separate gear storage at home',
							},
							{
								image: bike10x10,
								content:
									'### 10x10 Storage Unit\n\n' +
									'**Best for**: Most single-bike owners who want it done right\n\n' +
									'**Monthly cost**: $89-119\n\n' +
									'**Pro tip**: This is where most experienced riders end up. You can truly use the space, not just cram stuff into it.',
							},
							{
								image: bike10x15,
								content:
									'### 10x15 Storage Unit\n\n' +
									'**Best for**: Serious riders or those with multiple bikes\n\n' +
									'**Monthly cost**: $119-149\n\n' +
									'**Pro tip**: You can work on your bike in the space, organize equipment by season, and still have room to grow your collection',
							},
							{
								image: bike10x20,
								content:
									'### 10x20 Storage Unit\n\n' +
									'**Best for**: Multiple bikes, trailer storage, or a comprehensive workshop setup\n\n' +
									'**Monthly cost**: $149-189\n\n' +
									'**Pro tip**: Perfect for families with multiple riders or serious collectors.',
							},
						],
					},
				},
			],
		},

		{
			title: 'Content section - triple column',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Dirt Bike Storage: Outdoor vs Indoor',
						contentType: 'column-type',
						ShowBackgroundImage: true,
						content: [
							'### Covered Outdoor Parking\n\n' +
								'**Monthly cost**: $59-79\n\n' +
								'**Best for**:\n\n' +
								'- Riders in mild climates who access their bikes frequently\n\n' +
								'- Short term storage\n\n' +
								'- Easy access\n\n' +
								'- Most affordable dirt bike storage options\n\n',
							'### Indoor Storage\n\n' +
								'**Monthly cost**: $89-189+\n\n' +
								'**Best for**:\n\n' +
								'- A stable temperature prevents condensation\n\n' +
								'- Dust protection keeps your bike cleaner\n\n' +
								'- Enhanced security with multiple barriers\n\n' +
								'- Climate control options for serious investments',
						],
					},
				},
			],
		},

		{
			title: 'Content section - single column',
			background: 'white',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Dirt Bike Winter Storage 101',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Dirt bike [winter storage preparation](https://www.sparefoot.com/blog/how-to-prepare-your-car-for-winter) isn't just about parking your bike for a few months – it's about ensuring your ride revs up perfectly when riding season returns. Here's what separates amateur storage from intentional preparation:",
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'### 72-Hour Pre-Storage Protocol\n\n' +
								'**Days 1-2: Deep Clean and Inspect**\n\n' +
								'- Completely wash and dry (including chain and sprockets) your bike and accessories\n\n' +
								'- Document any existing damage with photos\n\n' +
								'- Check for loose bolts, worn parts, or developing issues\n\n' +
								'- Address any maintenance items now, not in spring\n\n',
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'**Day-3: Fluid and Fuel Management**\n\n' +
								'- Change the oil and filter (even if "not due yet")\n\n' +
								'- Choose your fuel strategy: stabilizer or complete drain\n\n' +
								'- Top off coolant and brake fluid\n\n' +
								'- Check hydraulic fluid levels\n\n',
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'#### Dirt Bike Winter Storage Pro Tips\n' +
								'- **Battery Management:**  [Remove and store indoors with a smart charger](https://www.sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries). Batteries left in cold storage units often fail by spring.\n\n' +
								'- **Tire Strategy:**  Either inflate to maximum pressure or use a bike stand. Flat spots from months of weight are expensive to fix.\n\n' +
								'- **Corrosion Prevention:**  Light oil on exposed metal, chain lubrication, and proper cover selection make the difference between spring maintenance and spring repair.\n\n',
						],
					},
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Why Choose SpareFoot for Dirt Bike Storage',
					},
				},
			],
		},

		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Dirt Bike Storage FAQs',
						faqs,
					},
				},
			],
		},

		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'dirt-bike-featured-content',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'September 22, 2025',
								image: dirtbikeFeatured1,
								content:
									'Protect Your Ride: Long-term Motorcycle Storage Tips',
								link: 'https://www.sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle',
							},
							{
								title: 'General Storage Advice',
								date: 'September 26, 2025',
								image: dirtbikeFeatured2,
								content:
									'Proper Storage Tips for Vehicle Batteries',
								link: 'https://www.sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries',
							},
							{
								title: 'How to Store It',
								date: 'October 22, 2025',
								image: dirtbikeFeatured3,
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
								link: 'https://www.sparefoot.com/blog/car-storage-size-guide',
							},
						],
					},
				},
			],
		},

		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'Motorcycle',
							'ATV',
							'Bicycle',
							'Car',
							'ClimateControl',
							'24Hour',
							'DriveUp',
						],
					},
				},
			],
		},

		{
			title: 'nearby units',
			noPaddingBottom: true,
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
